import { loadView } from '@/helper/utils'
import { mainLayout } from '@/components/layouts/Main'

export default {
  path: '/user',
  component: mainLayout(loadView('user/User')),
  children: [
    {
      path: 'registration',
      name: 'UserRegistration',
      component: loadView('user/registration/UserRegistration')
    },
    {
      path: 'registration/complete',
      name: 'UserRegistrationComplete',
      component: loadView('user/registration/UserRegistrationComplete')
    },
    {
      path: 'login',
      name: 'UserLogin',
      component: loadView('user/UserLogin')
    },
    {
      path: 'profile',
      name: 'UserProfile',
      component: loadView('user/profile/UserProfile'),
      meta: { requiresAuth: true },
      props: true
    },
    {
      path: 'profile/change',
      name: 'UserProfileChange',
      component: loadView('user/profile/UserProfileChange'),
      meta: { requiresAuth: true }
    },
    {
      path: 'mail/change',
      name: 'UserMailChange',
      component: loadView('user/mail/UserMailChange'),
      meta: { requiresAuth: true }
    },
    {
      path: 'mail/settings',
      name: 'UserMailSettings',
      component: loadView('user/mail/UserMailSettings'),
      meta: { requiresAuth: true }
    },
    {
      path: 'point/shortage',
      name: 'UserPointShortage',
      component: loadView('user/UserPointShortage'),
      meta: { requiresAuth: true }
    }
  ]
}
